import React,{useState, useRef} from 'react';
import { Helmet } from 'react-helmet';
import {Container} from 'react-bootstrap';
import {Row, Col, Tooltip } from 'antd';
import '@wartek-id/design-tokens/build/guru-desktop/css/color.css';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
const DetailInfoBerita = ({data, news}) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const link_url = location.href;
  async function copyToClip() {
    await navigator.clipboard.writeText(link_url);
    setCopySuccess(true);
  }

  const Print = () =>{     
    window.print();
  }
  return(
      <>
          <Helmet>
              <meta charSet="utf-8" />
              <title>Info & Berita | Situs Informasi SIPLah</title>
              <link rel="canonical" href="siplah.kemendikdasmen.go.id/info-berita" />
              <meta http-equiv="Cache-control" content="max-age=31536000"></meta>
              <meta name="title" content="Info & Berita | Situs Informasi SIPLah"></meta>
              <meta name="description" content="Lihat pengumuman terbaru, regulasi, informasi, dan liputan tentang SIPLah."></meta>
          </Helmet>
          <div className="h-100" id="printable">
            <section className="bg-dark-blue text-white section-pertanyaan-umum">
              <Container>
                <div className="d-flex m-b-24">
                  <a className="text-white" href="/info-berita">Info & Berita</a>
                  <span className="material-symbols-outlined">
                    navigate_next
                  </span>
                  <a className="text-white" href={`/info-berita/${data?.category?.id}`}>{data?.category?.name}</a>
                  <span className="material-symbols-outlined">
                    navigate_next
                  </span>
                  {data?.title}
                </div>
                <h1 className="font-switzer-bold text-white"><b>{data?.title}</b></h1>
                <hr className="text-white m-t-30 m-b-30"/>
                <div className="text-white font-size-14 text-uppercase">DIPUBLISH PADA {data?.published_at?.split(" ")[0]} {data?.published_at?.split(" ")[1]} {data?.published_at?.split(" ")[2]} &#183; {data?.category?.name}</div>
              </Container>
            </section>
            <section className="section-pertanyaan-umum">
              <Container>
                <Row gutter={[16, 16]}>
                  <Col lg={16} md={24} sm={24} xs={24}>
                    <div className="d-lg-none d-xl-none">
                    <div className="font-size-19 m-b-16"><b>Bagikan Informasi Ini</b></div>
                      <div className="d-flex align-items-center m-b-36">
                        <FacebookShareButton
                          url={link_url}
                          quote={data?.title}
                          hashtag={`#${data?.slug}`}
                        >
                          <button className="button-social-media-news"><img src="./assets/homepage/fb.svg" alt="facebook"/></button>
                        </FacebookShareButton>
                        <TwitterShareButton
                          url={link_url}
                          quote={data?.title}
                          hashtag={`#${data?.slug}`}
                        >
                          <button className="button-social-media-news"><img src="./assets/homepage/tw.svg" alt="twitter"/></button>
                        </TwitterShareButton>
                        <Tooltip trigger="click" onClick={()=> copyToClip()} title="Link copied">
                          <button className="button-social-media-news">
                            <span className="material-symbols-outlined">
                              link
                            </span>
                          </button>
                        </Tooltip>
                        <button className="button-social-media-news" onClick={Print}>
                          <span className="material-symbols-outlined">
                            print
                          </span>
                        </button>
                      </div>
                    </div>
                    <img src={data?.image_name} alt="detail info berita" className="img-block m-b-44"/>
                    <div dangerouslySetInnerHTML={{__html: data?.content}}/>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24} className="d-none d-lg-block d-xl-block">
                    <div className="font-size-19 m-b-16"><b>Bagikan Informasi Ini</b></div>
                    <div className="d-flex align-items-center m-b-36">
                      <FacebookShareButton
                        url={link_url}
                        quote={data?.title}
                        hashtag={`#${data?.slug}`}
                      >
                        <button className="button-social-media-news"><img src="/assets/homepage/fb.svg" alt="facebook"/></button>
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={link_url}
                        quote={data?.title}
                        hashtag={`#${data?.slug}`}
                      >
                        <button className="button-social-media-news"><img src="/assets/homepage/tw.svg" alt="twitter"/></button>
                      </TwitterShareButton>
                      <Tooltip trigger="click" onClick={()=> copyToClip()} title="Link copied">
                        <button className="button-social-media-news">
                          <span className="material-symbols-outlined">
                            link
                          </span>
                        </button>
                      </Tooltip>
                      <button className="button-social-media-news" onClick={Print}>
                        <span className="material-symbols-outlined">
                          print
                        </span>
                      </button>
                    </div>
                    <hr/>
                    <div className="font-size-19 m-t-30 m-b-24"><b>Informasi Terkait</b></div>
                    {news?.list?.slice(0,6).map((d,i)=>
                      <a className="category-berita" href={`/info-berita/${d.id}/detail`} key={i}>
                        <div className="title m-b-16">{d.title}</div>
                      </a>
                    )}
                  </Col>
                </Row>
              </Container>
            </section>
            <div className="display-flex overflow-x-hidden m-t-36">
              <span className="line-upper-footer bg-blue"/>
              <span className="line-upper-footer bg-orange"/>
              <span className="line-upper-footer bg-green"/>
              <span className="line-upper-footer bg-pink"/>
            </div>
          </div>
      </>
  )
}
export default DetailInfoBerita;